/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessNotifications.internal

import features.userBusinessNotifications.models.UserBusinessNotificationsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userBusinessNotifications.internal.UserBusinessNotificationsUseCase.Params

internal class UserBusinessNotificationsUseCase : AsyncUseCase<UserBusinessNotificationsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val userBusinessNotificationsService: UserBusinessNotificationsService = UserBusinessNotificationsServiceImpl()

    override suspend fun run(params: Params): Result<UserBusinessNotificationsModel> {
        return userBusinessNotificationsService.getUserBusinessNotifications(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
